import "./home.css";
import backgroundImage from "../../assets/images/header-background.jpg";
import aboutMeImg from "../../assets/images/stanislava-home-page2.jpg";
import leadsImg from "../../assets/images/stanislava-leads-img.jpg";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import Reviews from "../../components/reviews/Reviews";
import { useTranslation } from "react-i18next";

export default function Header() {
    const { t } = useTranslation();
    const [showHeader, setShowHeader] = useState(false);

    useEffect(() => {
        // 1. Показване на хедъра
        const timer = setTimeout(() => {
            setShowHeader(true);
        }, 500);

        // 2. Опции за скрол анимацията
        const observerOptions = {
            threshold: 0.05,
            rootMargin: "0px 0px -50px 0px"
        };

        // 3. Дефиниране на Observer-а
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add("active");
                }
            });
        }, observerOptions);

        // 4. Намиране и активиране на елементите
        const elementsToAnimate = document.querySelectorAll(".reveal");
        
        elementsToAnimate.forEach((el) => {
            // Веднага активираме тези, които вече са видими (важно за мобилни)
            if (el.getBoundingClientRect().top < window.innerHeight) {
                el.classList.add("active");
            }
            observer.observe(el);
        });

        // 5. Почистване при напускане на страницата
        return () => {
            clearTimeout(timer);
            elementsToAnimate.forEach((el) => observer.unobserve(el));
        };
    }, []);

    return (
        <>
            <div className="header-section">
                <img
                    className="header-background"
                    src={backgroundImage}
                    alt="header-background"
                />
                <div className={`header-content ${showHeader ? "fadeIn show" : "fadeIn"}`}>
                    <h2>{t("home.hero_title")}</h2>
                </div>
            </div>

            <div className="aboutMe">
                <div className="aboutMeContainer">
                    <div className="contentWrapper">
                        <h2 className="centered reveal">{t("home.welcome_title")}</h2>
                        
                        <div className="card-container reveal delay-1">
                            <div className="card">
                                <div className="card-body p-5">
                                    <div className="author-image-container d-flex justify-content-center mb-4">
                                        <img
                                            src={leadsImg}
                                            className="rounded-circle author-img"
                                            alt="Author"
                                        />
                                    </div>
                                    <figure className="text-center mb-0">
                                        <blockquote className="blockquote mb-4">
                                            <p>{t("home.quote")}</p>
                                        </blockquote>
                                        <figcaption className="blockquote-footer mb-0">
                                            {t("home.author")}
                                        </figcaption>
                                    </figure>
                                </div>
                            </div>
                        </div>

                        <p className="reveal delay-1">{t("home.p1")}</p>
                        <p className="reveal delay-2">{t("home.p2")}</p>
                        <p className="reveal delay-3">{t("home.p3")}</p>
                        <p className="reveal">{t("home.p4")}</p>
                        <p className="reveal">{t("home.p5")}</p>
                        
                        <p className="reveal">
                            <strong>{t("home.outro")}</strong>
                        </p>

                        <Link className="learnMoreButton reveal" to="/about">
                            {t("home.button")}
                        </Link>
                    </div>

                    <div className="aboutMeImagesContainer reveal delay-2">
                        <img src={aboutMeImg} alt="about-me" className="aboutMeImg" />
                    </div>
                </div>
            </div>

            <div className="reveal">
                <Reviews />
            </div>
        </>
    );
}